import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchImg from "../../../assets/provider/images/search1.svg";
import { api } from "../../../utlis/staff/api.utlis";
import TrashImg from "../../../assets/user/images/trash.svg";
import Loader from "../../../layouts/loader/Loader";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import ApiService from "../../../core/services/ApiService";
import DatePicker from "react-datepicker";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import DollarImg from "../../../assets/user/images/dollar.svg";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import moment from "moment";
import { LIMIT } from "../../../utlis/common.utlis";

const BudgetList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [budget, setBudget] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [month, setMonth] = useState(new Date());
  const [deleteBudget, setDeleteBudget] = useState({
    status: false,
    id: null,
  });
  const [editBudget, setEditBudget] = useState({
    status: false,
    id: null,
    title: null,
    date: null,
    price: null,
  });

  const initialEditValues = {
    budget_title: editBudget.title ?? "",
    budget: editBudget.price ?? "",
    budget_date:
      editBudget.date != "" &&
      editBudget.date != null &&
      editBudget.date != undefined
        ? moment(editBudget.date, "MM/YYYY", true).toDate()
        : null,
  };

  const validationSchema = Yup.object().shape({
    budget_title: Yup.string().required("Budget title is required!"),
    budget: Yup.string().required("Budget amount is required!"),
    budget_date: Yup.string().required("Budget month is required!"),
  });

  const getBudgetList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all transaction => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setBudget(response.data.data.budgetList);
      setTotal(response.data.data.total);
    } else setBudget([]);
    setLoading(false);
  };

  const deleteMonthBudget = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.budgetDelete + `${deleteBudget.id}`
    );
    setDeleteBudget(false);
    if (response.data.status) {
      toast.success(response.data.message);
      setMonth(null);
      getBudgetList(api.budgetList + `?page=${pageNum}&limit=${LIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const editMonthlyLimit = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      budget_title: formValue.budget_title,
      budget: formValue.budget,
      budget_date: moment(formValue.budget_date).format("MM/yyyy"),
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.budgetUpdate + `${editBudget.id}`,
      form
    );
    setEditBudget({
      status: false,
      id: null,
      title: null,
      date: null,
      price: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      setMonth(null);
      getBudgetList(api.budgetList + `?page=${pageNum}&limit=${LIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleFilter = (e, date) => {
    e.persist();
    let name = "";
    let month = "";
    let year = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "") {
      month = moment(date).format("MM");
      year = moment(date).format("yyyy");
    } else {
      month = "";
      year = "";
    }
    getBudgetList(
      api.budgetList +
        `?page=${pageNum}&limit=${LIMIT}&search=${name}&month=${month}&year=${year}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const selectedMonth = moment(month).format("MM");
    const selectedYear = moment(month).format("YYYY");

    getBudgetList(
      api.budgetList +
        `?page=${pageNum}&limit=${LIMIT}&month=${selectedMonth}&year=${selectedYear}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum, month]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container" style={{ minHeight: "400px" }}>
        <div className="care-expenses-section">
          <div className="care-title-header">
            <h2 className="heading-title">Budget Logs</h2>
            <div className="search-filter wd50">
              <div className="row g-2">
                <div className="col-md-4">
                  <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat="MM/yyyy"
                      selected={month}
                      onChange={(date, e) => {
                        setMonth(date);
                        handleFilter(e, date);
                      }}
                      className="form-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="Select Month/Year"
                      showMonthYearPicker
                    />
                  </div>
                </div>

                <div className="col-md-7">
                  <div className="form-group">
                    <div className="search-form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-1">
                  <Link className="btn-gr" to="" onClick={() => navigate(-1)}>
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {budget?.length !== 0 ? (
              budget?.map((ele, indx) => {
                return (
                  <div className="col-md-4" key={indx}>
                    <div className="log-expenses-card">
                      <div className="log-expenses-content">
                        <div className="log-expenses-head">
                          <div className="log-expenses-tag-list">
                            <div className="tags-item">
                              {ele.month_name ?? "NA"}
                            </div>
                          </div>
                          <div className="log-expenses-action">
                            <Link
                              className="edit-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                setEditBudget({
                                  status: true,
                                  id: ele.id,
                                  title: ele.budget_title,
                                  date: ele.budget_date,
                                  price: ele.budget,
                                });
                              }}
                            >
                              <img src={Edit2} />
                            </Link>
                            <Link
                              className="delete-btn"
                              to=""
                              onClick={() =>
                                setDeleteBudget({ status: true, id: ele.id })
                              }
                            >
                              <img src={TrashImg} />
                            </Link>
                          </div>
                        </div>
                        <h3 className="text-capitalize">
                          {ele.budget_title ?? "NA"}
                        </h3>
                        <div className="log-expenses-price-info">
                          <div className="log-expenses-price">
                            ${ele.budget ?? 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>

        <Modal
          show={editBudget.status}
          onHide={() => {
            setEditBudget({
              status: false,
              id: null,
              title: null,
              date: null,
              price: null,
            });
          }}
          className=""
        >
          <div className="modal-content">
            <ModalHeader>
              <h5 className="mb-0">Edit Monthly Budget Limit</h5>
            </ModalHeader>
            <ModalBody className="">
              <div className="add-items d-flex row">
                <Formik
                  initialValues={initialEditValues}
                  validateOnChange={true}
                  validationSchema={validationSchema}
                  onSubmit={editMonthlyLimit}
                  enableReinitialize
                >
                  {({ values, setFieldValue }) => (
                    <Form className="findcare-form">
                      <div className="findcare-card">
                        <div className="col-md-12 mb-3">
                          <div className="form-group mb-1">
                            <h4>Enter Budget Title</h4>
                            <Field
                              type="text"
                              className="form-control"
                              name="budget_title"
                              placeholder="Enter Budget Title"
                            />
                          </div>
                          <ErrorMessage
                            name="budget_title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Choose Budget Month</h4>
                            <Field name="budget_date" className="form-control">
                              {({ field }) => (
                                <DatePicker
                                  {...field}
                                  minDate={new Date()}
                                  selected={values.budget_date || ""}
                                  onChange={(value) =>
                                    setFieldValue("budget_date", value)
                                  }
                                  showIcon
                                  showMonthYearPicker
                                  dateFormat={"MM/yyyy"}
                                  className="form-control"
                                  style={{ padding: "15px 40px" }}
                                  autoComplete="off"
                                  placeholderText="Select Month"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="budget_date"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group search-form-group mb-1">
                            <h4>Enter Budget Amount</h4>
                            <Field
                              type="number"
                              className="form-control"
                              name="budget"
                              placeholder="Enter Budget Amount"
                            />
                            <span className="form-group-icon">
                              <img src={DollarImg} />
                            </span>
                          </div>
                          <ErrorMessage
                            name="budget"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="form-group text-end mt-3">
                          <button
                            type="button"
                            onClick={() => {
                              setEditBudget({
                                status: false,
                                id: null,
                                title: null,
                                date: null,
                                price: null,
                              });
                            }}
                            className="btn btn-re me-2"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-gr me-2"
                            data-bs-dismiss="modal"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </ModalBody>
          </div>
        </Modal>

        <Modal
          show={deleteBudget.status}
          onHide={() => {
            setDeleteBudget({ status: false, id: null });
          }}
          className="cc-modal-form"
        >
          <div className="modal-content">
            <ModalBody className="">
              <div className="add-items d-flex row">
                <div className="deleteaccount-Img">
                  <img src={deleteaccountImg} />
                </div>
                <div className="deleteaccount-text mb-4">
                  <h5 className="text-center pb-0">Delete Budget</h5>
                  <p className="text-center">
                    Deleting this budget cannot be undone. Are you sure you want
                    to proceed ?
                  </p>
                </div>
                <div className="form-group text-center mb-2">
                  <button
                    type="button"
                    onClick={() => setDeleteBudget({ status: false, id: null })}
                    className="btn-wh-re me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn-re"
                    data-bs-dismiss="modal"
                    onClick={() => deleteMonthBudget()}
                  >
                    Yes! Delete
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default BudgetList;
